$('[data-fancybox="main-product-card-slider"], .reviews-item__gallery a[data-fancybox], .photos-from-customers__item a[data-fancybox], .photos-from-customers__slider a[data-fancybox]').fancybox({
    arrows: true,
    loop: true,
    infobar: false,
    buttons: [
        "close"
    ],
    backFocus: false,
    btnTpl: {
        // Arrows
        arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left circular-control circular-control_secondary" title="{{PREV}}">' +
            '<div>' +
            '<svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.06981 10.1568C6.67928 10.5473 6.04612 10.5473 5.65559 10.1568L0.99884 5.5L5.65559 0.843247C6.04612 0.452723 6.67928 0.452723 7.06981 0.843247C7.46033 1.23377 7.46033 1.86694 7.06981 2.25746L3.82727 5.5L7.06981 8.74254C7.46033 9.13306 7.46033 9.76623 7.06981 10.1568Z" fill="#1A1A1A"/>' +
            '</svg>' +
            '</div>' +
            "</button>",

        arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right circular-control circular-control_secondary" title="{{NEXT}}">' +
            '<div><svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M0.930161 10.1568C1.32069 10.5473 1.95385 10.5473 2.34437 10.1568L7.00113 5.5L2.34437 0.843247C1.95385 0.452723 1.32069 0.452723 0.930161 0.843247C0.539637 1.23377 0.539637 1.86694 0.930161 2.25746L4.1727 5.5L0.930161 8.74254C0.539637 9.13306 0.539637 9.76623 0.930161 10.1568Z" fill="#1A1A1A"/>\n' +
            '</svg></div>' +
            "</button>",
    },

    thumbs : {
        autoStart   : true,                  // Display thumbnails on opening
        hideOnClose : true,                   // Hide thumbnail grid when closing animation starts
        parentEl    : '.fancybox-bg',  // Container is injected into this element
        axis        : 'x',                     // Vertical (y) or horizontal (x) scrolling
    },

});

